var map = {
	"./bg_panflet_mama.png": "/KIb",
	"./bg_panflet_papa.png": "l/bB"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Bvnx";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/parent_to_child ^\.\/bg_panflet_.*\.png$
// module id = Bvnx
// module chunks = 0